module.exports = __webpack_public_path__ + "static/media/slider1.57e269d7.png";